<template>
  <MasterDetail
    formTitle="Cadastro de Etapas ICT"
    :cols="cols"
    :opts="opts"
    :customResource="customResource"
    descriptionProperty="nome"
    serverPagination
  ></MasterDetail>
</template>

<script>
import MasterDetail from "@/components/master-detail.vue";
import ictEtapasService from "@/api/ict/ictEtapas.service";
import ictClientesService from "@/api/ict/ictClientes.service";
import ictProjetosService from "@/api/ict/ictProjetos.service";

export default {
  name: "IctEtapas",
  components: {
    MasterDetail,
  },
  computed: {
    empresaId() {
      return this.$store.getters.clientId;
    },
    customResource() {
      const empresaId = this.empresaId;
      return {
        get: (params) => ictEtapasService.getAll(empresaId, params),
        save: (data, id) => {
          const promise = id
            ? ictEtapasService.update(empresaId, id, data)
            : ictEtapasService.create(empresaId, data);
          return promise.catch(e => ({ error: e.response?.data?.message || "Falha ao salvar etapa." }));
        },
        delete: (id) => {
          return ictEtapasService.delete(empresaId, id)
            .catch(e => ({ error: e.response?.data?.message || "Falha ao excluir etapa." }));
        },
      };
    },
  },
  data() {
    return {
      cols: [
        {
          key: "id",
          name: "ID",
          hideInform: true,
        },
        {
          key: "nome",
          name: "Nome da Etapa",
          type: this.$fieldTypes.TEXT,
          colSize: 12,
          rules: [{ rule: "required" }],
          filterable: true,
        },
        {
          key: "cliente_id",
          name: "Instituição",
          type: this.$fieldTypes.SELECT,
          colSize: 12,
          rules: [{ rule: "required" }],
          filterable: true,
          rel: {
            key: "id",
            name: "razao_social",
            to: "clientes",
          },
        },
        {
          key: "projeto_id",
          name: "Projeto",
          type: this.$fieldTypes.SELECT,
          colSize: 12,
          rules: [{ rule: "required" }],
          filterable: true,
          rel: {
            key: "id",
            name: "nome_projeto",
            to: "projetos",
          },
        },
        {
          key: "data_inicio",
          name: "Data Início",
          type: this.$fieldTypes.DATE,
          colSize: 6,
        },
        {
          key: "data_fim",
          name: "Data Fim",
          type: this.$fieldTypes.DATE,
          colSize: 6,
        },
        {
          key: "descricao",
          name: "Descrição",
          type: this.$fieldTypes.TEXTAREA,
          colSize: 12,
        },
        {
          key: "resultado",
          name: "Resultado da Atividade",
          type: this.$fieldTypes.TEXTAREA,
          colSize: 12,
        },
        {
          key: "participantes",
          name: "Participantes",
          type: this.$fieldTypes.TEXTAREA,
          colSize: 12,
        },
        {
          key: "criado_em",
          name: "Criado Em",
          type: this.$fieldTypes.DATETIME,
          hideInform: true,
        },
      ],
      opts: {
        clientes: [],
        projetos: [],
      },
    };
  },
  methods: {
    confirmDeleteMessage({ nome }) {
      return `Deseja realmente deletar a etapa <b>"${nome}"</b>?`;
    },
    async loadOptions() {
      if (!this.empresaId) return;
      try {
        const [clientesRes, projetosRes] = await Promise.all([
          ictClientesService.getAll(this.empresaId),
          ictProjetosService.getAll(this.empresaId),
        ]);
        this.opts.clientes = clientesRes.data || clientesRes || [];
        this.opts.projetos = projetosRes.data || projetosRes || [];
      } catch (error) {
        console.error("Erro ao carregar opções para Etapas ICT:", error);
      }
    },
  },
  mounted() {
    this.loadOptions();
  },
};
</script>
